import { faUsers } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import classes from './NoAvailability.module.scss';

export const NoAvailability: React.FC = () => {
    return (
        <div className={classes.root}>
            <p>
                <div className={classes.icon}>
                    <FontAwesomeIcon icon={faUsers} />
                </div>
            </p>

            <p className={classes.title}>No Availability</p>
            <p>
                No staff available for all selected services. Check availability for one pet or
                contact the business for assistance.
            </p>
        </div>
    );
};
